import { useRepositories } from '../../../contexts';
import { InvalidationTag, LoaderType, useAppQuery } from '../utils';
import { useLanguage } from '../../../locale';
export var useGetActivityApi = function () {
    var _a = useLanguage(), locale = _a[2];
    var activityRepo = useRepositories().activityRepo;
    var getActivity = useAppQuery([InvalidationTag.Activity, locale], activityRepo.getActivity, {}, LoaderType.FullPage);
    return getActivity;
};
